'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _PersonModel = require('../modules/person/model/PersonModel');

var _PersonModel2 = _interopRequireDefault(_PersonModel);

var _PositionModel = require('../modules/position/model/PositionModel');

var _PositionModel2 = _interopRequireDefault(_PositionModel);

var _EducationModel = require('../modules/education/model/EducationModel');

var _EducationModel2 = _interopRequireDefault(_EducationModel);

var _OrganisationModel = require('../modules/organisation/model/OrganisationModel');

var _OrganisationModel2 = _interopRequireDefault(_OrganisationModel);

var _LogentryModel = require('../modules/logentry/model/LogentryModel');

var _LogentryModel2 = _interopRequireDefault(_LogentryModel);

var _LocationModel = require('../modules/location/model/LocationModel');

var _LocationModel2 = _interopRequireDefault(_LocationModel);

var _RelationshipModel = require('../modules/relationship/model/RelationshipModel');

var _RelationshipModel2 = _interopRequireDefault(_RelationshipModel);

var _FileModel = require('../modules/file/model/FileModel');

var _FileModel2 = _interopRequireDefault(_FileModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ModelMapper = function () {
  function ModelMapper() {
    _classCallCheck(this, ModelMapper);
  }

  _createClass(ModelMapper, [{
    key: 'mapToModel',
    value: function mapToModel(data, model) {
      for (var field in data) {
        model[field] = data[field];
      }
    }
  }, {
    key: 'mapToObject',
    value: function mapToObject(model, data) {
      for (var field in model) {
        data[field] = model[field];
      }
    }
  }, {
    key: 'initToModel',
    value: function initToModel(type, data) {
      switch (type) {
        case 'people':
          return new _PersonModel2.default(data);
        case 'positions':
          return new _PositionModel2.default(data);
        case 'educations':
          return new _EducationModel2.default(data);
        case 'organisations':
          return new _OrganisationModel2.default(data);
        case 'logentries':
          return new _LogentryModel2.default(data);
        case 'locations':
          return new _LocationModel2.default(data);
        case 'relationships':
          return new _RelationshipModel2.default(data);
        case 'files':
          return new _FileModel2.default(data);
      }
    }
  }]);

  return ModelMapper;
}();

exports.default = ModelMapper;


//////////////////
// WEBPACK FOOTER
// ./js/lib/ModelMapper.js
// module id = 6
// module chunks = 0